<div class="empty-state" [class.empty-state--full-width]="fullWidth()">
  <div class="icon-circle">
    <ng-content></ng-content>
  </div>
  @if (title()) {
    <div class="empty-title">{{ title() }}</div>
  }
  @if (body()) {
    <div class="empty-body">{{ body() }}</div>
  }
  @if (ctaLabel()) {
    <button class="empty-cta" (click)="ctaClicked.emit()">
      @if (ctaIcon()) {
        <ptl-icon [icon]="ctaIcon()!" size="s"></ptl-icon>
      }
      <span>{{ ctaLabel() }}</span>
    </button>
  }
</div>
